import {SliderGalleryIcon} from "@pg-design/slider-gallery-module";

export const renderInlineGalleryArrow = (position: "left" | "right", fill?: string) => (
    <SliderGalleryIcon fill={fill} iconSize="2.2" iconWrapperSize="4" position={position} wrapperColor="var(--colors-white)" />
);
import {SliderGalleryIcon} from "@pg-design/slider-gallery-module";

export const renderInlineGalleryArrow = (position: "left" | "right", fill?: string) => (
    <SliderGalleryIcon fill={fill} iconSize="2.2" iconWrapperSize="4" position={position} wrapperColor="var(--colors-white)" />
);
